import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormBuilder, } from '@angular/forms';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import * as _moment from 'moment';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { constants } from 'src/app/shared/common/contants';
import { UserMultiColumnDropdownComponent } from '../../user-multi-column-dropdown/user-multi-column-dropdown.component';
import { FitersserviceService } from './fitersservice.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { CommonPopupSearchComponent } from '../../common-popup-search/common-popup-search.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ReportlinksserviceService } from '../../reportlinks/reportlinksservice.service';
import { ManageVisualsService } from 'src/app/shared/services/manage-visuals.service';

const moment = _moment;

export interface ConditionalOPeratorTypeWhere {
  name: string,
  value: string
}

export interface LogicalOperatorTypeWhere {
  name: string,
  value: string
}
export interface filterPopupEditData {
  editData: any;
}
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}/${month}/${day}`;
  }
}
const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY/MM/DD',
  },
  display: {
    dateInput: 'YYYY/MM/DD',
    monthYearLabel: 'YYYY MMM',
    dateA11yLabel: 'YYYY/MM/DD',
    monthYearA11yLabel: 'YYYY MMMM',
  },
};
@Component({
    selector: 'app-filterspopup',
    templateUrl: './filterspopup.component.html',
    styleUrls: ['./filterspopup.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FilterspopupComponent implements OnInit {
  whereData = {"label":"", "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [],"excludeOrShowNull":"","priority":"","hideInVisuals":false,"mandatoryFilter":false,"showInQuicksightVisuals":false,"displayCalculatedFieldsIn":"columns"};
  reportCreationData = { "datasetname": "", "reportcreationid": "", "datasetObjectname": "", "datasetobjectattributes": [], "type": "", "description": "", "objectGroup": "", "filters": [], "sorting": [], "aggregate": [], "columns": [], "concatination": [], "rollingUp": [], "rollupExclusionObjects": [], "transformation": [], "columnFilters": [], "generateDefaultTemplate": "" };
  where = [];
  showFilter: boolean = false;
  buttonName: any;
  checked:any=false;
  uploadExternalFileChecked:any=false;
  hideInVisuals:boolean=false;
  mandatoryFilter:boolean=false;
  showInQuicksightVisuals:boolean=false;
  validations_form: UntypedFormGroup;
  validation_messages
  formValidWhere: UntypedFormGroup;
  fieldChange: boolean = true;
  maxORMinChange: boolean = false;
  dateChange: boolean = false;
  whereValueDateFormat = moment(null)
  fieldsData: any = [];
  dataSetObject = {
    datasetId: '',
    filtername: '',
    filterDescription: '',
    datasetName: '',
    reportcreationid: '',
    defaultFilter:"",
    filters: [],
    s3Path:'',
    isExternalFile:'',
    visualType:'',
    aggregate:[],
    pivotAggregation:[],
    selectedVisual: '',
    sorting: []
  }

  backgroundColorScreen = "";
  buttonColor = "";
  columnDefs;
  rowClassRules;
  defaultColDef;
  rowSelectionForTablesFields;
  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  pagesize;
  components: any;
  gridApi;
  show: boolean = false;
  selectedFieldsDataToPush: any = []
  filterData = [];
  dateField: boolean = false;
  multiselect: boolean = false;
  betweenField: boolean = false;
  multiSelectVaules = [];
  valueField: boolean = true;
  filterObjects: any = [];
  multiSelectKeyAttributes: any = [];
  reportCreationDetails: any = [];
  columns: any = []
  recordBetweenField: boolean = false;
  recordDateField: boolean = false;
  recordValueField: boolean = true;
  recordMultiselect: boolean = false;
  recordMultiField: boolean = true;
  recordMultiDate: boolean = false;
  recordscheduleRange: boolean = false;
  scheduleRange: boolean = false;
  between: boolean = false;
  selectedObject: any = []
  selectedAttribute;
  objectKeyList;
  attriburteKeyList;
  objectKeyValueArray;
  attributeKeyValueArray;
  updateData: any;
  datasetColumns:any;
  objectMetadata:any=[]
  aggregateData:any=[]
  pivotAggregateData: any = []
  sortingData: any = []
  selectedAggregates=[]
  selectedPivotAggregates = []
  selectedSorting = []
  updateDataSelectedAggregates=[]
  updateDataSelectedPivotAggregates = []
  updateDataSelectedSorting = []
  multiAttributeSelect=false
  visualType;
  visualData;
  selectedVisualId;
  selectedVisual
  selectedVisualArray

  constructor(private service: FitersserviceService, private msg: ErrorMessages, private snackbar: MatSnackBar, private dialog: MatDialog, private validation: validationmethod, private fb: UntypedFormBuilder, private formFieldsTrimer: FormFieldsTrimer, private localStorageSettings: LocalStorageSettingsService, private constants: constants,private linkservice: ReportlinksserviceService, private spinner: NgxUiLoaderService, public dialogref: MatDialogRef<FilterspopupComponent>, @Inject(MAT_DIALOG_DATA) public data: filterPopupEditData,private visualServices:ManageVisualsService,private filterService: FitersserviceService) {
    this.validation_messages = this.msg.filterMessages;
  }

  ngOnInit() {
   
    this.updateData = this.data.editData;
    console.log(this.updateData.filtermanageId)

    if (this.updateData.filtermanageId != undefined) {

      this.dataSetObject.filtername = this.updateData.filtername;
      this.dataSetObject.filterDescription = this.updateData.filterDescription;
      this.dataSetObject.datasetName = this.updateData.datasetname;
      this.dataSetObject.datasetId = this.updateData.datasetId;
      this.dataSetObject.defaultFilter = this.updateData.defaultFilter;
      this.dataSetObject.s3Path=this.updateData.s3Path;
      this.dataSetObject.isExternalFile =this.updateData.isExternalFile
      this.dataSetObject.selectedVisual = this.updateData.selectedVisual
      //this.dataSetObject.sorting = this.updateData.sorting;
      this.getVisuals(this.updateData.datasetId)
      if (this.updateData.selectedVisual && this.updateData.selectedVisual !== "") {
        this.selectedVisual = parseInt(this.updateData.selectedVisual, 10);
      }
      
      if(this.updateData.defaultFilter == "Yes"){
        this.checked=true;
      }else{
        this.checked=false;
      }

      if(this.updateData.isExternalFile == "Yes"){
        this.uploadExternalFileChecked=true;
      }else{
        this.uploadExternalFileChecked=false;
      }
     
      let fdata = JSON.parse(this.updateData.filters);
      console.log(fdata);
      this.where = fdata;

      /* Modified by Renuka on 9-04-2026
      Check if any filter has BETWEEN condition to display Value1 column*/
      if (fdata && fdata.length > 0) {
        this.between = fdata.some(filter => filter.whereCondition === "BETWEEN");
      }

      console.log(this.where)
      console.log(this.whereData);
      console.log(this.dataSetObject)
      if(fdata.length >0){
        this.showFilter=true;
        this.getObjectLables()
      }
      this.getReports()
      this.buttonName = "Update"
    } else {
      this.buttonName = "Save"
    }


    this.validations_form = this.fb.group({
      filtername: '',
      filterdescription: ''
    });

    this.formValidationsWhere();
    this.formValidation();

    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }

  formValidation() {
    
    this.validations_form = new UntypedFormGroup({

      selectdataSet: new UntypedFormControl('', [Validators.required,Validators.maxLength(100)]),
      selectAggregate:new UntypedFormControl(''),
      selectPivotAggregate: new UntypedFormControl(''),
      selectSorting: new UntypedFormControl(''),
      selectVisual:new UntypedFormControl(''),
      filtername: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator, Validators.maxLength(100)]),
      filterdescription: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator, Validators.maxLength(100)]),
      setAsDefaultFilter: new UntypedFormControl(''),
      uploadExternalFile: new UntypedFormControl(''),
      s3Path: new UntypedFormControl('')
    });
    this.onuploadExternalFileChange()
  }

  formValidationsWhere() {
    // form validations
    this.formValidWhere = new UntypedFormGroup({
      label: new UntypedFormControl('', []),
      objectWhere: new UntypedFormControl('', []),
      fieldsWhere: new UntypedFormControl('', []),
      conditionalOperatorWhere: new UntypedFormControl('', []),
      excludeOrShowNull:new UntypedFormControl('', []),
      priority:new UntypedFormControl('',[]),
      enterValueWhere: new UntypedFormControl('', []),
      multiselect: new UntypedFormControl('', []),
      hideInVisuals:new UntypedFormControl('', []),
      mandatoryFilter:new UntypedFormControl('', []),
      showInQuicksightVisuals:new UntypedFormControl('', []),
      maxORMin:new UntypedFormControl('', []),
      displayCalculatedFieldsIn:new UntypedFormControl('', [])
      
    });
  }

  conditionalOperatorDataWhere: ConditionalOPeratorTypeWhere[] = [
    { name: "Matches", value: "=" },
    { name: "Does Not Matches", value: "<>" },
    { name: "Matches At Least One (Exclude)", value: "NOT IN" },
    { name: "Matches At Least One", value: "IN" },
    { name: "Starts With", value: "Starts with" },
    { name: "Contains (Exclude)", value: "Contains (Exclude)" },
    { name: "Ends With", value: "Ends with" },
    { name: "Contains", value: "contains" },
    { name: "Greater Than Or Equals", value: ">=" },
    { name: "Is Greater Than", value: ">" },
    { name: "Less Than Or Equals", value: "<=" },
    { name: "Is Less Than", value: "<" },
    { name: "Between", value: "BETWEEN" },
    { name: "Space Separated", value: "Space Separated" },
    { name: "Space Separated (Exclude)", value: "Space Separated (Exclude)" },
    { name: "MAX", value: "MAX" },
    { name: "MIN", value: "MIN" },
    { name: "Calculated Field", value: "CalculatedField" },
    { name: "Calculated Field With Filter", value: "CalculatedFieldWithFilter" },
    { name: "Calculated Field For Reports", value: "CalculatedFieldForReports" },
    { name: "Count", value: "count"}
  ];

  logicalOperatorDataWhere: LogicalOperatorTypeWhere[] = [
    { name: "And", value: "And" },
    { name: "Or", value: "Or" }
  ];

  addWhere() {
    console.log(this.whereData);
    
    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {
      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.whereData);
      this.formFieldsTrimer.clean(this.whereData);
      if ((this.whereData.label == undefined || this.whereData.objectWhere == undefined || this.whereData.fieldsWhere == undefined || this.whereData.conditionalOperatorWhere == undefined || this.whereData.conditionalOperatorWhere == undefined)&& (this.whereData.fieldsWhere !=="count")) {
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
      } else if (this.whereData.priority == undefined  && this.whereData.conditionalOperatorWhere !== 'MAX' && this.whereData.conditionalOperatorWhere !== 'MIN'&& this.whereData.conditionalOperatorWhere !== 'count' ) {
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
      } else {
        this.whereData.logicalOperatorWhere = "AND";
        let objectName = "";
        this.filterData.forEach(object => {
          if (object.alias === this.whereData.fieldsWhere) {
            objectName = object.name;
          }
        })
        var whereValue;
        if (this.whereData.conditionalOperatorWhere === "IN"||this.whereData.conditionalOperatorWhere === "NOT IN") {
          var multipleValue;
          var multiValue = "";
          multipleValue = this.whereData.multiSelect;
          let value;
          if(!multipleValue){
            multipleValue=[]
            value = multipleValue
          }else{
            value = multipleValue.split(",")
          }

          console.log(multipleValue)



          if (value.length == 0) {
            this.snackbar.open("Not a valid filter. Please select value to Add filter", "OK", { duration: 5000 });
          }
          for (let index = 0; index < value.length; index++) {
            const element = value[index];
            multiValue = multiValue + "'" + element + "'";
            if (index != value.length - 1) {
              multiValue = multiValue + ",";
            }
          };
          if(multiValue){
            whereValue = "(" + multiValue + ")";
          }else{
            whereValue=""
          }
          let tempWhere = {
            "label":this.whereData.label,
            "objectWhere": this.getValueByKey(this.whereData.objectWhere, this.objectKeyValueArray),
            "whereKey": this.getValueByKey(this.whereData.fieldsWhere, this.attributeKeyValueArray),
            "whereKeyAlias": this.selectedAttribute,
            "whereCondition": this.whereData.conditionalOperatorWhere,
            "whereConditionValue":this.whereData.conditionalOperatorWhere,
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere,
            "excludeNull":false,
            "showOnlyNulls":false,
            "priority":this.whereData.priority,
            "hideInVisuals":this.hideInVisuals,
            "mandatoryFilter":this.mandatoryFilter,
            "showInQuicksightVisuals":this.showInQuicksightVisuals,
            "displayCalculatedFieldsIn":this.whereData.displayCalculatedFieldsIn
          }

          if(this.whereData.excludeOrShowNull == "excludeNull"){
            tempWhere.excludeNull=true
          }else if(this.whereData.excludeOrShowNull == "showOnlyNull"){
            tempWhere.showOnlyNulls=true
          }

          this.where.push(tempWhere);
          tempWhere = {"label":"", "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "","whereConditionValue":"", "whereValue": "", "whereValue1": "", "whereLogic": "","excludeNull":false,"priority":"", "showOnlyNulls":false,"hideInVisuals":false,"mandatoryFilter":false,"showInQuicksightVisuals":false,"displayCalculatedFieldsIn":"columns" }
      } else if (this.whereData.conditionalOperatorWhere === "BETWEEN") {
          this.between = true;
          if (this.dateChange) {
            if(this.whereData.enterValueBetweenStart){
              this.whereValueDateFormat = moment(this.whereData.enterValueBetweenStart)
              this.whereData.enterValueBetweenStart = moment(this.whereValueDateFormat).format('YYYY/MM/DD');
              console.log(this.whereData.enterValueBetweenStart)
            }else{
              this.whereValueDateFormat = undefined;
              this.whereData.enterValueBetweenStart ="";
              console.log(this.whereData.enterValueBetweenStart)
            }

            if(this.whereData.enterValueBetweenEnd){
              this.whereValueDateFormat = moment(this.whereData.enterValueBetweenEnd)
              this.whereData.enterValueBetweenEnd = moment(this.whereValueDateFormat).format('YYYY/MM/DD');
            }else{
              this.whereValueDateFormat = undefined;
            this.whereData.enterValueBetweenEnd = "";
            }

            console.log(this.whereData.enterValueBetweenEnd)
            let tempWhere = {
              "label":this.whereData.label,
              "objectWhere": this.getValueByKey(this.whereData.objectWhere, this.objectKeyValueArray),
              "whereKey": this.getValueByKey(this.whereData.fieldsWhere, this.attributeKeyValueArray),
              "whereKeyAlias": this.selectedAttribute,
              "whereCondition": this.whereData.conditionalOperatorWhere,
              "whereConditionValue":this.whereData.conditionalOperatorWhere,
              "whereValue":this.whereData.enterValueBetweenStart,
              "whereValue1":this.whereData.enterValueBetweenEnd,
              "whereLogic": this.whereData.logicalOperatorWhere,
              "excludeNull":false,
              "priority":this.whereData.priority,
              "showOnlyNulls":false,
              "hideInVisuals":this.hideInVisuals,
              "mandatoryFilter":this.mandatoryFilter, 
              "showInQuicksightVisuals":this.showInQuicksightVisuals,
              "displayCalculatedFieldsIn":this.whereData.displayCalculatedFieldsIn
            }

            if(this.whereData.excludeOrShowNull == "excludeNull"){
              tempWhere.excludeNull=true
            }else if(this.whereData.excludeOrShowNull == "showOnlyNull"){
              tempWhere.showOnlyNulls=true
            }

            this.where.push(tempWhere);
            tempWhere = {  "label":"","objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "","whereConditionValue":"", "whereValue": "", "whereValue1": "", "whereLogic": "","excludeNull":false,"showOnlyNulls":false, "priority":"", "hideInVisuals":false,"mandatoryFilter":false,"showInQuicksightVisuals":false,"displayCalculatedFieldsIn":"columns"}
            } else {
            if(this.whereData.enterValueBetweenEnd == undefined){
              this.whereData.enterValueBetweenEnd=""
            }
            if(this.whereData.enterValueBetweenStart == undefined){
              this.whereData.enterValueBetweenStart=""
            }
            let tempWhere = {
              "label":this.whereData.label,
              "objectWhere": this.getValueByKey(this.whereData.objectWhere, this.objectKeyValueArray),
              "whereKey": this.getValueByKey(this.whereData.fieldsWhere, this.attributeKeyValueArray),
              "whereKeyAlias": this.selectedAttribute,
              "whereCondition": this.whereData.conditionalOperatorWhere,
              "whereConditionValue":this.whereData.conditionalOperatorWhere,
              "whereValue": this.whereData.enterValueBetweenStart,
              "whereValue1": this.whereData.enterValueBetweenEnd,
              "whereLogic": this.whereData.logicalOperatorWhere,
              "excludeNull":false,
              "priority":this.whereData.priority,
              "showOnlyNulls":false,
              "hideInVisuals":this.hideInVisuals,
              "mandatoryFilter":this.mandatoryFilter,
              "showInQuicksightVisuals":this.showInQuicksightVisuals,
              "displayCalculatedFieldsIn":this.whereData.displayCalculatedFieldsIn
            }
            if(this.whereData.excludeOrShowNull == "excludeNull"){
              tempWhere.excludeNull=true
            }else if(this.whereData.excludeOrShowNull == "showOnlyNull"){
              tempWhere.showOnlyNulls=true
            }

            this.where.push(tempWhere);
            tempWhere = { "label":"", "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "","whereConditionValue":"", "whereValue": "", "whereValue1": "", "whereLogic": "", "excludeNull":false, "showOnlyNulls":false, "priority":"", "hideInVisuals":false, "mandatoryFilter":false,"showInQuicksightVisuals":false,"displayCalculatedFieldsIn":"columns"}
          }
        } else if (this.whereData.conditionalOperatorWhere === "Ends with") {
          if (this.dateField) {
            console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
            
             if(this.whereData.enterValueWhereDate){
               this.whereValueDateFormat = moment(this.whereData.enterValueWhereDate)
               whereValue = moment(this.whereValueDateFormat).format('YYYY/MM/DD');
             }else{
               this.whereValueDateFormat = undefined;
               whereValue ='';
             }
             
           }else{
            if(this.whereData.enterValueWhere){
            whereValue = "'%" + this.whereData.enterValueWhere + "'";
            }else{
              whereValue=""
            }
          }
          let tempWhere = {
            "label":this.whereData.label,
            "objectWhere": this.getValueByKey(this.whereData.objectWhere, this.objectKeyValueArray),
            "whereKey": this.getValueByKey(this.whereData.fieldsWhere, this.attributeKeyValueArray),
            "whereKeyAlias": this.selectedAttribute,
            "whereCondition": "LIKE",
            "whereConditionValue":this.whereData.conditionalOperatorWhere,
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere,
            "excludeNull":false,
            "showOnlyNulls":false,
            "priority": this.whereData.priority,
            "hideInVisuals":this.hideInVisuals,
            "mandatoryFilter":this.mandatoryFilter,
            "showInQuicksightVisuals":this.showInQuicksightVisuals,
            "displayCalculatedFieldsIn":this.whereData.displayCalculatedFieldsIn
          }

          if(this.whereData.excludeOrShowNull == "excludeNull"){
            tempWhere.excludeNull=true
          }else if(this.whereData.excludeOrShowNull == "showOnlyNull"){
            tempWhere.showOnlyNulls=true
          }

          this.where.push(tempWhere);
          tempWhere = { "label":"", "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "","whereConditionValue":"", "whereValue": "", "whereValue1": "", "whereLogic": "", "excludeNull":false, "showOnlyNulls":false, "priority":"", "hideInVisuals":false,"mandatoryFilter":false,"showInQuicksightVisuals":false,"displayCalculatedFieldsIn":"columns"};
        } else if (this.whereData.conditionalOperatorWhere === "Starts with") {
          if (this.dateField) {
            console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
            
             if(this.whereData.enterValueWhereDate){
               this.whereValueDateFormat = moment(this.whereData.enterValueWhereDate)
               whereValue = moment(this.whereValueDateFormat).format('YYYY/MM/DD');
             }else{
               this.whereValueDateFormat = undefined;
               whereValue ='';
             }
             
           }else{
            if(this.whereData.enterValueWhere){
            whereValue = "'" + this.whereData.enterValueWhere + "%'";
            }else{
              whereValue="";
            }
          }
          let tempWhere = {
            "label":this.whereData.label,
            "objectWhere": this.getValueByKey(this.whereData.objectWhere, this.objectKeyValueArray),
            "whereKey": this.getValueByKey(this.whereData.fieldsWhere, this.attributeKeyValueArray),
            "whereKeyAlias": this.selectedAttribute,
            "whereCondition": "LIKE",
            "whereConditionValue":this.whereData.conditionalOperatorWhere,
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere,
            "excludeNull":false,
            "showOnlyNulls":false,
            "priority": this.whereData.priority,
            "hideInVisuals":this.hideInVisuals,
            "mandatoryFilter":this.mandatoryFilter,
            "showInQuicksightVisuals":this.showInQuicksightVisuals,
            "displayCalculatedFieldsIn":this.whereData.displayCalculatedFieldsIn
          }
          if(this.whereData.excludeOrShowNull == "excludeNull"){
            tempWhere.excludeNull=true
          }else if(this.whereData.excludeOrShowNull == "showOnlyNull"){
            tempWhere.showOnlyNulls=true
          }

          this.where.push(tempWhere);
          tempWhere = {  "label":"","objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "","whereConditionValue":"", "whereValue": "", "whereValue1": "", "whereLogic": "", "excludeNull":false,"showOnlyNulls":false, "priority":"", "hideInVisuals":false,"mandatoryFilter":false,"showInQuicksightVisuals":false,"displayCalculatedFieldsIn":"columns"}
        } else if (this.whereData.conditionalOperatorWhere === "contains") {
          if (this.dateField) {
            console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
            
             if(this.whereData.enterValueWhereDate){
               this.whereValueDateFormat = moment(this.whereData.enterValueWhereDate)
               whereValue = moment(this.whereValueDateFormat).format('YYYY/MM/DD');
             }else{
               this.whereValueDateFormat = undefined;
               whereValue ='';
             }
             
           }else{
            if(this.whereData.enterValueWhere){
              whereValue = "'%" + this.whereData.enterValueWhere + "%'";
              }else{
                whereValue = "";
              }
           }
          
          let tempWhere = {
            "label":this.whereData.label,
            "objectWhere": this.getValueByKey(this.whereData.objectWhere, this.objectKeyValueArray),
            "whereKey": this.getValueByKey(this.whereData.fieldsWhere, this.attributeKeyValueArray),
            "whereKeyAlias": this.selectedAttribute,
            "whereCondition": "LIKE",
            "whereConditionValue":this.whereData.conditionalOperatorWhere,
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere,
            "excludeNull":false,
            "showOnlyNulls":false,
            "priority": this.whereData.priority,
            "hideInVisuals":this.hideInVisuals,
            "mandatoryFilter":this.mandatoryFilter,
            "showInQuicksightVisuals":this.showInQuicksightVisuals,
            "displayCalculatedFieldsIn":this.whereData.displayCalculatedFieldsIn
          }
          if(this.whereData.excludeOrShowNull == "excludeNull"){
            tempWhere.excludeNull=true
          }else if(this.whereData.excludeOrShowNull == "showOnlyNull"){
            tempWhere.showOnlyNulls=true
          }

          this.where.push(tempWhere);
          tempWhere = { "label":"", "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "","whereConditionValue":"", "whereValue": "", "whereValue1": "", "whereLogic": "", "excludeNull":false,"showOnlyNulls":false, "priority":"", "hideInVisuals":false,"mandatoryFilter":false,"showInQuicksightVisuals":false,"displayCalculatedFieldsIn":"columns"}
                } else if (this.whereData.conditionalOperatorWhere === "Contains (Exclude)") {
          if (this.dateField) {
            console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
            
             if(this.whereData.enterValueWhereDate){
               this.whereValueDateFormat = moment(this.whereData.enterValueWhereDate)
               whereValue = moment(this.whereValueDateFormat).format('YYYY/MM/DD');
             }else{
               this.whereValueDateFormat = undefined;
               whereValue ='';
             }
             
           }else{
            if(this.whereData.enterValueWhere){
              whereValue = "'%" + this.whereData.enterValueWhere + "%'";
              }else{
                whereValue = "";
              }
           }
          
          let tempWhere = {
            "label":this.whereData.label,
            "objectWhere": this.getValueByKey(this.whereData.objectWhere, this.objectKeyValueArray),
            "whereKey": this.getValueByKey(this.whereData.fieldsWhere, this.attributeKeyValueArray),
            "whereKeyAlias": this.selectedAttribute,
            "whereCondition": "NOT LIKE",
            "whereConditionValue":this.whereData.conditionalOperatorWhere,
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere,
            "excludeNull":false,
            "showOnlyNulls":false,
            "priority": this.whereData.priority,
            "hideInVisuals":this.hideInVisuals,
            "showInQuicksightVisuals":this.showInQuicksightVisuals,
            "displayCalculatedFieldsIn":this.whereData.displayCalculatedFieldsIn
          }
          if(this.whereData.excludeOrShowNull == "excludeNull"){
            tempWhere.excludeNull=true
          }else if(this.whereData.excludeOrShowNull == "showOnlyNull"){
            tempWhere.showOnlyNulls=true
          }

          this.where.push(tempWhere);
          tempWhere = { "label":"", "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "","whereConditionValue":"", "whereValue": "", "whereValue1": "", "whereLogic": "", "excludeNull":false,"showOnlyNulls":false, "priority":"", "hideInVisuals":false,"showInQuicksightVisuals":false,"displayCalculatedFieldsIn":"columns"}
        }
        else {
          console.log("*********************************************");
          
          if (this.dateField) {
           console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
           
            if(this.whereData.enterValueWhereDate){
              this.whereValueDateFormat = moment(this.whereData.enterValueWhereDate)
              whereValue = moment(this.whereValueDateFormat).format('YYYY/MM/DD');
            }else{
              this.whereValueDateFormat = undefined;
              whereValue ='';
            }

          } else {
            if(this.whereData.enterValueWhere){
              whereValue = "'" + this.whereData.enterValueWhere + "'";
            }else{
              whereValue = "";
            }
           
            this.whereData.enterValueWhere = whereValue;
          }
          let tempWhere = {
            "label":this.whereData.label,
            "objectWhere": this.getValueByKey(this.whereData.objectWhere, this.objectKeyValueArray),
            "whereKey": this.getValueByKey(this.whereData.fieldsWhere, this.attributeKeyValueArray),
            "whereKeyAlias": this.selectedAttribute,
            "whereCondition": this.whereData.conditionalOperatorWhere,
            "whereConditionValue":this.whereData.conditionalOperatorWhere,
            "whereValue":  whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere,
            "excludeNull":false,
            "showOnlyNulls":false,
            "priority": this.whereData.priority,
            "hideInVisuals":this.hideInVisuals,
            "mandatoryFilter":this.mandatoryFilter,
            "showInQuicksightVisuals":this.showInQuicksightVisuals,
            "displayCalculatedFieldsIn":this.whereData.displayCalculatedFieldsIn
          }
          if(this.whereData.excludeOrShowNull == "excludeNull"){
            tempWhere.excludeNull=true
          }else if(this.whereData.excludeOrShowNull == "showOnlyNull"){
            tempWhere.showOnlyNulls=true
          }

          this.where.push(tempWhere);
          tempWhere = { "label":"", "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "","whereConditionValue":"", "whereValue": "", "whereValue1": "", "whereLogic": "", "excludeNull":false,"showOnlyNulls":false, "priority": "", "hideInVisuals":false,"mandatoryFilter":false,"showInQuicksightVisuals":false,"displayCalculatedFieldsIn":"columns" };
        }
        this.showFilter = true;
        this.whereData = { "label":"","objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [],"excludeOrShowNull":"", "priority": "", "hideInVisuals":false,"mandatoryFilter":false,"showInQuicksightVisuals":false,"displayCalculatedFieldsIn":"columns"};
        this.dateChange = false;
        this.dateField = false;
        this.multiselect = false;
        this.fieldChange = true;
        this.scheduleRange = false;
        this.betweenField = false;
        this.hideInVisuals=false;
        this.mandatoryFilter=false;
        this.showInQuicksightVisuals=false;
        this.maxORMinChange=false;
        this.multiAttributeSelect=false;

        console.log(this.where);

        // this.formValidWhere.reset();

        this.formValidationsWhere();
        this.multiSelectVaules = [];
        this.filterData = [];
      }

    }
    // this.whereData.objectWhere = null;
    console.log(this.whereData.objectWhere);

  }

  attrbuteSelection(event) {
    console.log(event);
    this.whereData.conditionalOperatorWhere="";
    this.multiselect=false;
    this.whereData.multiSelect=[];
    this.whereData.enterValueWhere="";
    this.selectedAttribute = event.value;
    let caseObject = this.getValueByKey(this.whereData.objectWhere, this.objectKeyValueArray);
    let attribute = this.getValueByKey(this.whereData.fieldsWhere, this.attributeKeyValueArray);
    let objectName = "";
    this.attriburteKeyList.forEach(object => {
      if (object === this.whereData.fieldsWhere) {
        console.log(object);
        objectName = caseObject + "_" + attribute.replace(".", "_");
      }
    })
    var multiselectElement = false;
    this.multiSelectKeyAttributes.forEach(value => {
      if (value === objectName) {
        multiselectElement = true;
        this.multiselect = true;
      }
    });
    for (let objectIndex = 0; objectIndex < this.attriburteKeyList.length; objectIndex++) {
      let object = this.attriburteKeyList[objectIndex];
      // if (typeof object === 'string') {
        if (object === event.value) {
          this.dateField = this.checkIfAttributeTypeIsDate(event.value,this.getValueByKey(object, this.attributeKeyValueArray));
          break;
        } else {
          this.dateField = false;
        }
      // }
    }
    if (this.dateField) {
      this.valueField = false;
      this.fieldChange = false;
      this.multiselect = false;
      this.maxORMinChange=false;
    } else {
      this.fieldChange = true;
      this.dateField = false;
      this.dateChange = false;
      this.maxORMinChange=false
    }
    this.betweenField = false;
    this.whereData.conditionalOperatorWhere = "";
    if (multiselectElement) {
      if (objectName === undefined || objectName === '' || objectName.length === 0) {
        return;
      }
      this.spinner.start();
      this.betweenField = false;
      this.dateField = false;
      this.fieldChange = false;
      this.maxORMinChange=false
      this.multiselect = true;
      let event = { value: "IN" }
      this.whereData.conditionalOperatorWhere = "IN";
      this.recordFilterCondition(event);
      this.multiSelectVaules = [];
      this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationDetails.objectGroup, objectName).subscribe(response => {
        console.log(response);
        if (response != null) {
          var sampleData = response;
          // var data = sampleData[0].split(",");
          var data = JSON.parse(sampleData[0]);
          console.log(data.length);
          
          for (let elementIndex = 0; elementIndex < data.length; elementIndex++) {
            let element = data[elementIndex];
            // if (element.includes("[")) {
            //   element = element.replace("[", "");
            // }
            // if (element.includes("]")) {
            //   element = element.replace("]", "");
            // }
            // if (element.includes("\"")) {
            //   element = element.replace("\"", "");
            //   element = element.replace("\"", "");
            // }
            let dataTemplate = { "alias": "" };
            dataTemplate.alias = element;
            this.multiSelectVaules.push(dataTemplate);
            console.log("*********************");

          }
          console.log(this.multiSelectVaules);
         // this.multiSelectVaules=this.multiSelectVaules.sort((a, b) => a.alias.localeCompare(b.alias));
        } else {
          this.snackbar.open("No Facet declared for selected attribute", "OK", { duration: 5000 });
        }
      });
      this.spinner.stop();
    }
  }
  checkIfAttributeTypeIsDate(alias,name){
    let columns = JSON.parse(this.reportCreationDetails.columns);

 

    for(let i=0;i<columns.length;i++){
      if((columns[i].alias === alias && columns[i].name === name) && 
      (columns[i].type === "DateTime" || columns[i].type === "Date")){    
        return true;
      }else{
        if(i == columns.length-1){
          return false;
        }
      }
    }
  }
  recordFilterCondition(event) {
    this.recordscheduleRange = false;
    if (event.value === "BETWEEN") {
      this.recordValueField = false;
      this.recordBetweenField = true;
      if (this.recordDateField) {
        this.recordMultiDate = true;
        this.recordDateField = false;
      } else {
        this.recordMultiField = true;
      }
      this.recordMultiselect = false;
    } else if (event.value === "IN") {
      if (this.recordDateField || this.recordMultiDate) {
        console.log(this.recordDateField, ",", this.recordMultiDate);

      } else {
        this.recordMultiselect = true;
        this.recordBetweenField = false;
        this.recordDateField = false;
        this.recordValueField = false;
      }
    } else if (event.value === "schedule range") {
      this.recordValueField = false;
      this.recordBetweenField = false;
      this.recordMultiselect = false;
      this.recordDateField = false;
      this.recordMultiDate = false;
      this.recordMultiField = false;
      this.recordscheduleRange = true;
    } else {
      this.recordMultiselect = false;
      if (this.recordDateField) {
        this.recordValueField = false;
        this.recordDateField = true;
      } else {
        if (this.recordMultiDate) {
          this.recordValueField = false;
          this.recordDateField = true;
          this.recordMultiDate = false;
        } else {
          this.recordValueField = true;
          this.recordDateField = false;
        }
      }
      this.recordBetweenField = false;
    }
  }

  whereKey(e) {
    //this.whereData.objectWhere = e.value;
    this.getAlias(e.value);
    this.fieldChange = true;
    this.dateChange = false;
    this.dateField = false;
    this.multiselect=false;
    this.maxORMinChange=false
    console.log(e)
    console.log(this.fieldsData)
    this.whereData.conditionalOperatorWhere="";
    this.whereData.fieldsWhere="";
    this.whereData.multiSelect=[];
    this.whereData.enterValueWhere="";
    console.log(this.whereData);

    for (let i = 0; i < this.fieldsData.length; i++) {
      if (this.fieldsData[i].townshipNameAndFields == e) {
        if (this.fieldsData[i].datatype == "Date") {
          this.dateChange = !this.dateChange;
          this.fieldChange = false;
        } else {
          this.dateChange = false;
        }
      }
    }
    this.spinner.start()
    this.service.retrieveReportCretion(this.dataSetObject.datasetId).subscribe(response => {
      if (response != null) {
        console.log(response);
        // this.reportCreationDetails = Object.entries(response).map(([key, value]) => ({
        //   [Object.keys(key)[0]]: Object.values(value)[0],
        // }));
        this.reportCreationDetails=response
        console.log(this.reportCreationDetails);
        this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationDetails.objectGroup, "Keys").subscribe(response => {
          if (response != null && !response.error) {
            console.log(response);
            this.multiSelectKeyAttributes = response;
            console.log(this.multiSelectKeyAttributes);
          }
          this.spinner.stop();
        });
      }
    })



  }

  deleteWhere(k) {
    console.log(k)
    this.where.splice(k, 1);
    if (this.where.length == 0) {
      this.showFilter = false;
    }
  }



  createreport() {
console.log(JSON.stringify([{"alias":"Total Ids","orderBy":"Case ID (id)","reporting":"Y","aggregateColumn":"Case ID (id)","conditionalValue":"","aggregateFunction":"count","partitionByColumn":"Case ID (id)"},{"alias":"Total count","orderBy":"Case Product Drug Role (drug_role__v_name__v)","reporting":"Y","aggregateColumn":"Case Product Drug Role (drug_role__v_name__v)","conditionalValue":"Suspect,Concomitant","aggregateFunction":"count","partitionByColumn":"Case Product Drug Role (drug_role__v_name__v)"}]));
  console.log(this.dataSetObject)
    if (!this.validations_form.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.validations_form);

      this.validation.getvalidationmessage();

    } else {
   
  console.log(this.dataSetObject)
  console.log(this.where)
    if (!this.where || this.where.length === 0) {
    this.snackbar.open("Please add atleast one valid filter", "OK", { duration: 5000 });
    return;
  }
  for (let i in this.where) {
  //const filter = this.dataSetObject.filters[i];
  console.log(this.where[i].whereCondition);

  if (this.where[i].whereCondition === "MAX" || this.where[i].whereCondition === "MIN" || this.where[i].whereCondition === "count"  || this.where[i].whereCondition === "CalculatedField" || this.where[i].whereCondition === "CalculatedFieldWithFilter" || this.where[i].whereCondition === "CalculatedFieldForReports" ) {
    this.where[i].hideInVisuals = true;
  }
} 
      if (this.buttonName === "Update") {
        this.dataSetObject.filters = this.where
        
       
        console.log(this.dataSetObject)
        this.service.updateFilterRecord(this.updateData.filtermanageId,this.dataSetObject).subscribe(response => {
          this.spinner.start();
          console.log(response);
          // checking if response is true or not
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
          this.spinner.stop();
          this.dialogref.close();
          this.cancel()
          window.location.reload()
        });

      } else {
        this.dataSetObject.filters = this.where
        console.log(this.dataSetObject)
        this.service.insertFilters(this.dataSetObject).subscribe(response => {
          this.spinner.start();
          console.log(response);
          // checking if response is true or not
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
          this.spinner.stop();
          this.dialogref.close();

        });
      }
    }



  }

  filterCondition(event) {
   
    console.log(event)
    console.log(this.dateField);

    if (event.value === "BETWEEN") {
      this.fieldChange = false;
      this.betweenField = true;
      this.multiAttributeSelect = false;
      if (this.dateField) {
        this.dateChange = true;
        this.dateField = false;
      } else {
        this.valueField = true;
      }
      this.multiselect = false;
      this.maxORMinChange=false
    } else if (event.value === "IN" || event.value === "NOT IN") {
      this.multiAttributeSelect = false;
      if (this.dateField || this.dateChange) {
        console.log(this.dateField, ",", this.dateChange);

      } else {
        this.multiAttributeSelect = false;
        this.multiselect = true;
        this.betweenField = false;
        this.dateField = false;
        this.fieldChange = false;
        this.maxORMinChange=false
      }
    } else if(event.value === "MAX" || event.value === "MIN"){
      this.multiAttributeSelect = false;
      this.multiselect = false;
        this.betweenField = false;
        this.dateField = false;
        this.fieldChange = false;
        this.maxORMinChange=true
    }else if (event.value === "schedule range") {
      this.multiAttributeSelect = false;
      this.multiselect = false;
      this.betweenField = false;
      this.dateField = false;
      this.fieldChange = false;
      this.dateChange = false;
      this.valueField = false;
      this.maxORMinChange=false
    }else if(event.value === "count"){
      this.multiAttributeSelect = true;
      this.maxORMinChange=true
      this.multiselect = false;
      this.betweenField = false;
      this.dateField = false;
      this.fieldChange = false;
    } else {
      this.multiAttributeSelect = false;
      this.multiselect = false;
      if (this.dateField) {
        this.fieldChange = false;
        this.dateField = true;
      } else {
        if (this.dateChange) {
          this.fieldChange = false;
          this.dateField = true;
          this.dateChange = false;
        } else {
          this.fieldChange = true;
          this.dateField = false;
          this.maxORMinChange=false
        }
      }
      this.betweenField = false;
    }
  }

  userMultiDropdown() {
    let dialogRef = this.dialog.open(UserMultiColumnDropdownComponent, {
      width: "70%",
      autoFocus: false,
      data: { ObjectId: this.dataSetObject.datasetId }
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined) {
        console.log(result);
        
        this.selectedFieldsDataToPush = [];
        console.log(this.dataSetObject.datasetName);
        if(this.dataSetObject.datasetName==null||this.dataSetObject.datasetName==undefined||this.dataSetObject.datasetName!=result.datasetname){
          this.where=[]
          this.showFilter=false;
          console.log(this.dataSetObject.datasetName)
          console.log(result.datasetname)

        }
        this.dataSetObject.datasetId = result.reportcreationid;
        this.dataSetObject.datasetName = result.datasetname;
        this.dataSetObject.visualType=result.visualType;
        console.log(this.dataSetObject.datasetId)
        this.getObjectLables();
        this.selectedFieldsDataToPush = JSON.parse(result.datasetobjectattributes);
        this.datasetColumns=JSON.parse(result.columns);
        this.aggregateData=JSON.parse(result.aggregate);
        this.pivotAggregateData = JSON.parse(result.pivotAggregation);
        this.sortingData = JSON.parse(result.sorting);
        console.log(this.sortingData)
        // this.service.retrieveFieldsData(result.datasetname)
        //   .subscribe(arg => {console.log(arg)
        //   });
        console.log(this.datasetColumns);
        
        console.log(this.selectedFieldsDataToPush);
        this.selectedVisualArray=[]
        this.selectedVisual=""
        this.getVisuals(this.dataSetObject.datasetId)
        // this.pushDataToSelectedFieldsGrid();
      }
    });
  }

  searchableDropdown() {
    var columndata = []
    var c = {
      "alias": "Alias",
    }
   columndata.push(c)
    console.log(this.multiSelectVaules)
    console.log(this.multiSelectVaules.length)
   
    console.log(this.dataSetObject)
    let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
      width: "70%",
      autoFocus: false,
      data: { edata:this.multiSelectVaules,page:"multiple",columns:columndata,selectedValue:this.whereData.multiSelect,selectedPropertyName:"alias"}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      //console.log(value)
      if (result != undefined) {
       this.whereData.multiSelect=result.selectedRows.map(item => item.alias);
      // this.whereData.multiSelect= [{key:"value"},{key:"value2"}]
      }
    });

  }

  searchableSingleSelectForAtributies(){
    var columndata = []
    var c = {
      "alias": "Alias",
    }
   columndata.push(c)
   console.log(this.reportCreationDetails.columns);
   
    console.log(JSON.parse(this.reportCreationDetails.columns))
   
    console.log(this.dataSetObject)
    let columns = JSON.parse(this.reportCreationDetails.columns);
    console.log(columns);
    let newObject={
      "alias":"None"
    }
    columns.unshift(newObject);
    let page="single"
    if(this.multiAttributeSelect){
      page = "multiple"
    }
    let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
      width: "70%",
      autoFocus: false,
      data: { edata:columns,page:page,columns:columndata,selectedValue:this.whereData.enterValueWhere,selectedPropertyName:"alias"}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      //console.log(value)
      if (result != undefined) {
        console.log(result.selectedRows.map(item => item.alias));
       
        if(this.multiAttributeSelect){
          console.log(this.whereData.fieldsWhere)
          let multiSelectAttributes = result.selectedRows.map(item => item.alias)
          // Remove the value and convert to comma-separated string


          multiSelectAttributes.push(this.whereData.fieldsWhere);
          const duplicateCount = multiSelectAttributes.filter(attr => attr === this.whereData.fieldsWhere).length;
          if(duplicateCount>1){
            let removed = false;
            this.selectedAttribute = multiSelectAttributes
              .filter(attr => {
                if (attr === this.whereData.fieldsWhere && !removed) {
                  removed = true; // remove only the first duplicate
                  return false;
                }
                return true;
              })
              .join(',');
          }else{
            this.selectedAttribute = multiSelectAttributes.join(',');
          }


           this.whereData.enterValueWhere =  this.selectedAttribute
           console.log(this.selectedAttribute)
        }else{
          this.whereData.enterValueWhere=result.selectedRows.map(item => item.alias);
        }
       
      // this.whereData.multiSelect= [{key:"value"},{key:"value2"}]
      }
    });

  }

  get multiSelectString(): string {
    return this.whereData.multiSelect.map(item => item.alias).join(', ');
  }
  cancel() {

    this.where = [];
    this.selectedFieldsDataToPush = [];
    this.whereData = {"label":"", "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [],"excludeOrShowNull":"", "priority": "", "hideInVisuals":false,"mandatoryFilter":false,"showInQuicksightVisuals":false,"displayCalculatedFieldsIn":"columns"};

    this.dataSetObject = {
      datasetId: '',
      filtername: '',
      filterDescription: '',
      datasetName: '',
      reportcreationid: '',
      defaultFilter:'',
      filters: [],
      s3Path:'',
      isExternalFile:'',
      visualType:'',
      aggregate:[],
      pivotAggregation:[],
      selectedVisual: '',
      sorting: []
    }
    this.dateChange = false;
    this.show = false;
    this.formValidation();
    this.formValidationsWhere();
    this.dialogref.close();
  }

  getValueByKey(keyToFind: string, keyVlaueArray): string | undefined {
    const resultObject = keyVlaueArray.find((item) => keyToFind in item);
    return resultObject ? resultObject[keyToFind] : undefined;
  }

  getObjectLables() {
    this.service.retrieveObjects(this.dataSetObject.datasetId).subscribe(response => {
      console.log(response);
      if (response != null) {
        this.objectKeyList = Object.values(response).map((item) => Object.keys(item)[0]);
        this.objectKeyValueArray = Object.entries(response).map(([key, value]) => ({
          [Object.keys(value)[0]]: Object.values(value)[0],
        }));
      } else {
        this.snackbar.open("No Objects is added for seceted Dataset", "OK", { duration: 5000 });
      }
    });
  }

  getAlias(event) {
    console.log(event)
    this.service.retrieveAlias(event, this.dataSetObject.datasetId).subscribe(response => {
      console.log(response);
      if (response != null) {
        this.attriburteKeyList = Object.values(response).map((item) => Object.keys(item)[0]);
        this.attributeKeyValueArray = Object.entries(response).map(([key, value]) => ({
          [Object.keys(value)[0]]: Object.values(value)[0],
        }));
      } else {
        this.snackbar.open("No Objects is added for seceted Dataset", "OK", { duration: 5000 });
      }
    });
  }

  onDefaultFilterChange(){
    if(this.checked){
      this.dataSetObject.defaultFilter="Yes"
    }else{
      this.dataSetObject.defaultFilter ="No"
    }
  }
  onuploadExternalFileChange(){
    if(this.uploadExternalFileChecked){
      this.dataSetObject.isExternalFile="Yes"
      this.validations_form.controls["s3Path"].setValidators([Validators.required,this.validation.noWhitespaceValidator]);
      this.validations_form.controls["s3Path"].updateValueAndValidity();
      this.spinner.start();
      let tenantId =Number(this.localStorageSettings.getSettings("dnsName"))
      this.service.getDataFromObjectMetaDataByDnsIdAndCategory(tenantId,"External").subscribe(response =>{
        console.log(response);
        if(!response.error){
          this.objectMetadata=response
          this.spinner.stop();
        }
        this.spinner.stop();
      })

    }else{
      this.dataSetObject.isExternalFile="No"
      this.dataSetObject.s3Path='';
      this.validations_form.controls["s3Path"].clearValidators();
      this.validations_form.controls["s3Path"].updateValueAndValidity();
    }
   
  }

  onAggregateChange(event){
    console.log(event);
    console.log(this.selectedAggregates);
    let aggregateArray=this.aggregateData.filter(data=>this.selectedAggregates.includes(data.alias));
    
    this.dataSetObject.aggregate=aggregateArray
    console.log( this.dataSetObject.aggregate);
  }

 onPivotAggregateChange(event: any) {
  console.log('Selected values:', this.selectedPivotAggregates);

  const pivotAggregateArray: any[] = [];

  for (const item of this.pivotAggregateData) {
     if (item.pivotTable === 'Yes' && Array.isArray(item.pivotMetadata)) {
      const filteredMetadata = item.pivotMetadata.filter(meta =>
        this.selectedPivotAggregates.includes(meta.totalAlias)
      );
      if (filteredMetadata.length > 0) {
        pivotAggregateArray.push({
          pivotTable: 'Yes',
          pivotMetadata: filteredMetadata
        });
      }
    } else if (item.pivotTable === 'No') {
      if (this.selectedPivotAggregates.includes(item.totalAlias)) {
        pivotAggregateArray.push(item);
      }
    }
  }

  this.dataSetObject.pivotAggregation = pivotAggregateArray;
  console.log(this.dataSetObject.pivotAggregation);
  }
  onSortingchnage(event) {
    console.log(event);
    console.log(this.selectedSorting);
    let selectedSortingArray = this.sortingData.filter(data => this.selectedSorting.includes(data.orderKeyAlias));

    this.dataSetObject.sorting = selectedSortingArray
    console.log(this.dataSetObject.sorting);
  }

  clearDate(event){
    console.log(event);
    this.whereData.enterValueWhereDate = null
  }
  onHideVisuals(event){
console.log(event);
console.log(this.whereData);
  }
  
  onMandatoryFilter(event){
     this.mandatoryFilter = event.checked;
    console.log(event);
  }
  dateFormatForTitle(event){
    return moment(event).format('YYYY/MM/DD')
  }
  /*
   Author - Shyam
   Date: 11/08/2024
   @note: To handle the drag-and-drop event for filters grid
  */
  drop(event: CdkDragDrop<any[]>): void {
    // Reorder array based on drag-and-drop
    moveItemInArray(this.where, event.previousIndex, event.currentIndex);
  }
  getReports(){
    this.spinner.start()
    this.linkservice.retrievereport(this.localStorageSettings.getSettings("UserId"), this.localStorageSettings.getSettings("dnsName"), this.localStorageSettings.getSettings("AuthUsername")).subscribe(response =>{
      console.log(response);
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      } else {
        
        
        console.log(response)
        console.log(this.dataSetObject.datasetId);

        let datasets:any=response
        let selectedDataset=datasets.filter(dataset=>{ return dataset.reportcreationid == this.dataSetObject.datasetId})
        console.log(selectedDataset);
        
        this.aggregateData=JSON.parse(selectedDataset[0].aggregate);
        this.pivotAggregateData = JSON.parse(selectedDataset[0].pivotAggregation); 
        this.sortingData = JSON.parse(selectedDataset[0].sorting);
        if(this.updateData.aggregate!==null){
          this.updateDataSelectedAggregates=JSON.parse(this.updateData.aggregate)
        }else{
          this.updateDataSelectedAggregates=[];
        }
        if(this.updateData.pivotAggregation!==null){
          this.updateDataSelectedPivotAggregates=JSON.parse(this.updateData.pivotAggregation)
        }else{
          this.updateDataSelectedPivotAggregates=[];
        }
        if (this.updateData.sorting !== null) {
          this.updateDataSelectedSorting = JSON.parse(this.updateData.sorting);
        } else {
          this.updateDataSelectedSorting = [];
        }
        
        if(this.updateDataSelectedAggregates.length >0){
          // this.selectedAggregates = this.updateDataSelectedAggregates.map(item => item.alias)
          this.validations_form.controls["selectAggregate"].setValue(this.updateDataSelectedAggregates.map(item => item.alias))
          let aggregateArray=this.aggregateData.filter(data=>this.selectedAggregates.includes(data.alias));
          console.log( this.dataSetObject.aggregate);
          this.dataSetObject.aggregate=aggregateArray
          console.log( this.dataSetObject.aggregate);
          
        }

        if(this.updateDataSelectedPivotAggregates.length >0){
          // this.selectedAggregates = this.updateDataSelectedAggregates.map(item => item.alias)
          const selectedPivotAliases: string[] = [];

       /**
       * modified by Renuka chama
       * 06/08/2025
       * code modified to display correct JSON for pivotaggregate in Filter
       */

  for (const item of this.updateDataSelectedPivotAggregates) {
    if (item.pivotTable === 'Yes' && Array.isArray(item.pivotMetadata)) {
      for (const meta of item.pivotMetadata) {
        selectedPivotAliases.push(meta.totalAlias);
      }
    } else if (item.totalAlias) {
      selectedPivotAliases.push(item.totalAlias);
    }
  }
  this.validations_form.controls["selectPivotAggregate"].setValue(selectedPivotAliases);
    
   const pivotAggregateArray: any[] = [];

  for (const item of this.pivotAggregateData) {
    if (item.pivotTable === 'Yes' && Array.isArray(item.pivotMetadata)) {
      const filteredMetadata = item.pivotMetadata.filter(meta =>
       selectedPivotAliases.includes(meta.totalAlias)
      );
      if (filteredMetadata.length > 0) {
        pivotAggregateArray.push({
          pivotTable: 'Yes',
          pivotMetadata: filteredMetadata
        });
      }
    } else if (item.pivotTable === 'No') {
      if (selectedPivotAliases.includes(item.totalAlias)) {
              pivotAggregateArray.push(item);
      }
    }
  }
          console.log( this.dataSetObject.pivotAggregation);
          this.dataSetObject.pivotAggregation=pivotAggregateArray
          console.log( this.dataSetObject.pivotAggregation);
          
        }
        if (this.updateDataSelectedSorting.length > 0) {
          console.log(this.updateDataSelectedSorting)
          // this.selectedAggregates = this.updateDataSelectedAggregates.map(item => item.alias)
          this.validations_form.controls["selectSorting"].setValue(this.updateDataSelectedSorting.map(item => item.orderKeyAlias))
          console.log(this.sortingData)
          console.log(this.selectedSorting);
          let SortingArray = this.sortingData.filter(data => this.selectedSorting.includes(data.orderKeyAlias));
          console.log(SortingArray)
          console.log(this.dataSetObject.sorting);
          this.dataSetObject.sorting = SortingArray
          console.log(this.dataSetObject.sorting);

        }


      }
      this.spinner.stop()
    })
  }




  getVisuals(dataSetId){
    this.spinner.start();
    this.visualServices.retreiveManageVisualsDataOnDatasetId(dataSetId).subscribe(response=>{
      if (response.error == true) {
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      } else {
        console.log(response);
        let visualList:any=response
        this.visualData=visualList.filter(visual=>visual.status=="Yes"&&visual.visualType=="Tabular");
        if(this.updateData!=null&&this.updateData.selectedVisual !== ""){
          this.validations_form.controls["selectVisual"].setValue(parseInt(this.updateData.selectedVisual, 10))
        }
        this.spinner.stop();
        
      }
    })
  }

  onVisualSelectionChanged(event) {
    console.log(event);
    console.log(this.selectedVisualId);
    console.log(this.selectedVisual);
  
  
  
if(this.selectedVisual==undefined){
  this.dataSetObject.selectedVisual=""
}
else{
    this.dataSetObject.selectedVisual = this.selectedVisual;
    
    
    console.log(this.selectedVisual);
  }
}
  
}
